module.exports = { raw: '9.3.1' };



//////////////////
// WEBPACK FOOTER
// ./~/auth0-js/src/version.js
// module id = 170
// module chunks = 0